import { gql } from '@apollo/client';

const getSupplierOrderStatuses = gql`query getSupplierOrderStatuses{
	incomingOrdersContext{
		listOrderStatuses
		{
			id
			name
			actions
			productionStatus
			color
			actionTrigger
			userMustConfirmAction
		}
	}
}`;

export default getSupplierOrderStatuses;